{
  "title": "Передача местоположения позволяет ускорить процесс регистрации",
  "body": "К сожалению, без доступа к вашему местоположению мы не можем завершить регистрацию. Пожалуйста, предоставьте доступ к геолокации для продолжения. Мы используем ваше местоположение исключительно для регистрации на складе и не храним и не передаём информацию о вашем местоположении третьим лицам.",
  "shareLocation": "Передать моё местоположение"
}
